/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.30",
    versionName: "0.2.0-nightly.2025.10.30",
    versionChannel: "nightly",
    buildDate: "2025-10-30T00:08:38.367Z",
    commitHash: "ea5d0ff6754575767fe343cd2bb7fa12f0734735",
};
